import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-deepCharcoal pt-24 pb-12 px-6 md:px-12 border-t border-white/5" data-id="element-70">
      <div className="max-w-7xl mx-auto" data-id="element-71">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20" data-id="element-72">
          {/* Column 1: Brand */}
          <div data-id="element-73">
            <h3 className="text-gold text-2xl font-bold tracking-widest uppercase mb-4" data-id="element-74">
              Glenlofty
            </h3>
            <p className="text-gray-400 font-light tracking-wide" data-id="element-75">
              Pyrenees, Victoria
            </p>
          </div>

          {/* Column 2: Explore */}
          <div data-id="element-76">
            <h4 className="text-white text-sm font-bold tracking-widest uppercase mb-6" data-id="element-77">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-78">
              {['About', 'Wines', 'Sustainability', 'Contact'].map(item => <li key={item} data-id="element-79">
                  <a href="#" className="text-gray-400 hover:text-gold transition-colors duration-300 font-light" data-id="element-80">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Wine Ranges */}
          <div data-id="element-81">
            <h4 className="text-white text-sm font-bold tracking-widest uppercase mb-6" data-id="element-82">
              Wine Ranges
            </h4>
            <ul className="space-y-4" data-id="element-83">
              {['GO Range', 'Estate Reserve', 'Single Block'].map(item => <li key={item} data-id="element-84">
                  <a href="#" className="text-gray-400 hover:text-gold transition-colors duration-300 font-light" data-id="element-85">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div data-id="element-86">
            <h4 className="text-white text-sm font-bold tracking-widest uppercase mb-6" data-id="element-87">
              Connect
            </h4>
            <address className="not-italic text-gray-400 font-light mb-6 space-y-2" data-id="element-88">
              <p data-id="element-89">257 Glenlofty-Warrenmang Rd</p>
              <p data-id="element-90">Glenlofty VIC 3469</p>
              <p className="pt-2" data-id="element-91">
                <a href="tel:+61353546222" className="hover:text-gold" data-id="element-92">
                  +61 3 5354 6222
                </a>
              </p>
              <p data-id="element-93">
                <a href="mailto:info@glenlofty.com.au" className="hover:text-gold" data-id="element-94">
                  info@glenlofty.com.au
                </a>
              </p>
            </address>
            <div className="flex space-x-6" data-id="element-95">
              {[InstagramIcon, FacebookIcon, TwitterIcon].map((Icon, i) => <a key={i} href="#" className="text-gold hover:text-white transition-colors duration-300" data-id="element-96">
                  <Icon className="w-6 h-6" data-id="element-97" />
                </a>)}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gold/20 mb-8" data-id="element-98"></div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-600 font-light tracking-wide" data-id="element-99">
          <div className="mb-4 md:mb-0" data-id="element-100">
            &copy; {new Date().getFullYear()} Glenlofty Estate. All rights
            reserved.
          </div>
          <div className="flex space-x-6" data-id="element-101">
            <a href="#" className="hover:text-gray-400" data-id="element-102">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-103">
              Terms of Service
            </a>
          </div>
        </div>
        <div className="text-center mt-8 text-[10px] text-gray-700 uppercase tracking-widest" data-id="element-104">
          WARNING: Under the Liquor Control Reform Act 1998 it is an offence to
          supply alcohol to a person under the age of 18 years (Penalty exceeds
          $19,000), for a person under the age of 18 years to purchase or
          receive liquor (Penalty exceeds $800).
        </div>
      </div>
    </footer>;
}